import { Controller } from "@hotwired/stimulus"

// Reloads to a URL after a delay — used on the subscription page while a just-completed Stripe
// checkout is still being provisioned by the async webhook, so the plan flips to active without a
// manual reload. The target URL carries a bumped `try` counter; the view stops rendering this
// controller once the subscription is active (or after a few tries), so the loop ends on its own.
export default class extends Controller {
  static values = { url: String, delay: { type: Number, default: 4000 } }

  connect() {
    this.timer = setTimeout(() => { window.location.href = this.urlValue }, this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
